import type { DragEndEvent } from '@dnd-kit/core'
import { arrayMove } from '@dnd-kit/sortable'
import type { Updater } from '@tanstack/react-table'

/** Reorder visible column ids on drag-end while preserving hidden column positions in full order. */
export function createColumnDragEndHandler(
  getVisibleColumnIds: () => string[],
  handleColumnOrderChange: (updater: Updater<string[]>) => void,
) {
  return (event: DragEndEvent) => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const visibleIds = getVisibleColumnIds()
    const oldIndex = visibleIds.indexOf(String(active.id))
    const newIndex = visibleIds.indexOf(String(over.id))
    if (oldIndex === -1 || newIndex === -1) return

    const newVisibleOrder = arrayMove(visibleIds, oldIndex, newIndex)

    handleColumnOrderChange((prev) => {
      const hiddenIds = prev.filter((id) => !visibleIds.includes(id))
      let visibleIdx = 0
      let hiddenIdx = 0
      return prev.map((id) =>
        visibleIds.includes(id) ? newVisibleOrder[visibleIdx++] : hiddenIds[hiddenIdx++],
      )
    })
  }
}
